<div class="hds-panel-layout-main-container bg-light-gray">
  <section>
    <div class="d-block sticky-element"
         style="z-index: 11;">
      <div class="hds-page-header">
        <div class="hds-page-header-main-container">
          <div class="hds-page-header-menu">
            <div class="hds-page-header-menu-list">
              <div class="hds-page-header-menu-list-item">
                <div class="hds-page-title-simple">
                  <h1 style="font-weight:500;padding-left:18px;font-size: 1.5rem;" id="optim-title" optim-menu-title="dashboard">{{ 'dashboard.title' | translate}}</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="hds-page-header-sidemenu">
          <div class="hds-page-header-menu">
            <div class="hds-page-header-menu-list">
              <ng-container *ngIf="!isOnEditView; else editView">
                <div *ngIf="isConsultant && !isProd" class="hds-page-header-menu-list-item" appFoundation>
                  <button (click)="onToggleDemoMode()" class="button margin-r-xs border-radius-xlarge cell auto" style="cursor: pointer" [ngClass]="toggleDemoMode ? 'warning' : 'info'">
                    {{(toggleDemoMode ? 'dashboard.demo-mode-activated' : 'dashboard.demo-mode-deactivated') | translate}}
                  </button>
                </div>
                <div class="hds-page-header-menu-list-item" appFoundation>
                  <button (click)="openManageAdvertisingDialog()" *ngIf="isAdvertisingAdministrator"
                          class="button info margin-r-xs border-radius-xlarge cell auto"
                          type="submit">
                    {{'advertising.manage-advertisings' | translate}}
                  </button>
                </div>
                <ng-container *ngIf="isBackOfficeUser">
                  <div class="hds-page-header-menu-list-item" appFoundation>
                    <button (click)="openManageEventAdministrationDialog()" *ngIf="isAdvertisingAdministrator"
                            class="button info margin-r-xs border-radius-xlarge cell auto"
                            type="submit">
                      {{'event.manage-button' | translate}}
                    </button>
                  </div>
                </ng-container>

                <div class="hds-page-header-menu-list-item" appFoundation>
                  <a (click)="toggleEditView()"
                     id="optim-widget-customize"
                     class="button hollow primary border-radius-default font-500 margin-r-s">
                    <span style="font-size:1.2rem;">{{'dashboard.customize' | translate}}</span>
                    <span class="opt opt-edit margin-l-s" style="font-size:1.2rem;"></span>
                  </a>
                </div>

              </ng-container>
              <ng-template #editView>

                <div class="hds-page-header-menu-list-item" appFoundation>
                  <a (click)="reinitializeDashboard()"
                     id="optim-widget-reinitialization"
                     class="button border-radius-default font-500 margin-r-s hollow">
                    <span style="font-size:1.2rem;">{{'dashboard.reinitialization' | translate}}</span>
                  </a>

                  <a (click)="openAvailableWidgetCatalog()"
                     id="optim-available-widget-catalog"
                     class="button border-radius-default font-500 margin-r-s hollow">
                    <span style="font-size:1.2rem;">{{'dashboard.access-to-available-widgets-catalog' | translate}}</span>
                  </a>

                  <a (click)="toggleEditView()"
                     id="optim-widget-validate"
                     class="button success border-radius-default font-500 margin-r-s">
                    <span style="font-size:1.2rem;">{{'dashboard.validate' | translate}}</span>
                    <span class="opt far fa-check margin-l-s" style="font-size:1.2rem;"></span>
                  </a>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Layout Widgets -->
    <div class="d-block padding-all-l auto-height-panel" id="optim-widget" appAutoHeightElement>
      <div id="defaultLayout-container" class="control-section" data-toggler="dashboard-edit-mode" appFoundation>
        <ejs-dashboardlayout *ngIf="dashboard"
                             id='defaultLayout'
                             #defaultLayout
                             [columns]='columns'
                             [cellSpacing]='[cellSpacing, cellSpacing]'
                             [cellAspectRatio]='cellAspectRatio'
                             [allowDragging]="isOnEditView"
                             (change)="onPanelsChange($event)">
          <e-panels>

            <ng-container *ngFor="let widget of dashboard.widgets">
              <e-panel [id]="widget.id"
                       [sizeX]="getSize(widget.size, true)"
                       [sizeY]="getSize(widget.size, false)"
                       [row]="getPosition(widget, true)"
                       [col]="getPosition(widget, false)"
                       [zIndex]="3">

                <ng-template #content>
                  <app-widget [widget]="widget"
                              [isEditable]="isOnEditView"
                              [dashboardId]="dashboard.id"
                              (removeWidget)="removeWidgetFromDashboard($event)">
                  </app-widget>
                </ng-template>

              </e-panel>
            </ng-container>

          </e-panels>
        </ejs-dashboardlayout>
      </div>
    </div>
  </section>
</div>
